import moment from "moment";
import React, { useState } from "react";
import {
  Col,
  FormGroup,
  Input,
  InputGroup,
  InputGroupAddon,
  Label,
  Row,
} from "reactstrap";
import PageBody from "../../../components/PageBody";
import IconEdit from "../../../assets/images/icon-edit.png";
import Select from "react-select";
import { useHistory } from "react-router";
import ModalPopup from "../../../components/ModalPopup";
import CustomerAdd from "../../customer/CustomerAdd";
import AddressAdd from "../../customer/components/AddressAdd";
import APIClient from "../../../helpers/APIClient";
import { baseUrl } from "../../../constants/environment";
import { toast } from "react-toastify";
import AddressChange from "../../customer/components/AddressChange";
import TextUtils from "../../../helpers/TextUtils";

const OrderAddCustomer = (props: any) => {
  const { data, setData, type, onlyView, customers, onFreshCustomers } = props;
  const router = useHistory();
  const [modalIsOpen, setIsOpen] = useState(false);
  const [action, setAction] = useState<any>();

  const handleActionModal = (item: any) => {
    setAction(item)
    setIsOpen(true);
  }

  const handleSaveCusstomerAddress = async (address: any) => {
    let shipping_address = ''
    let address_default = address?.filter((itemFil:any)=> itemFil?.status === 1)
    if(address_default[0]) {
      address_default = address_default[0]
      shipping_address = address_default?.street || ""
      if(address_default?.wards_code?.name) shipping_address += ", " + address_default?.wards_code?.name
      if(address_default?.district_code?.name) shipping_address += ", " + address_default?.district_code?.name
      if(address_default?.provinces_code?.name) shipping_address += ", " + address_default?.provinces_code?.name
    }
    
    // Update cho customer đấy luôn nhé
    const url = `${baseUrl}/customer/address/${data?.customer_id?.id}`;
    
    let response: any = await APIClient.POST(url, {
      ...address_default,
      district_code: address_default?.district_code?.code,
      provinces_code: address_default?.provinces_code?.code,
      wards_code: address_default?.wards_code?.code,
    });
    if (response.error !== undefined) {
      toast.error(response.error.error_description)
    } else if (response.response !== undefined) {
      setData({
        ...data,
        customer_id: {
          ...data?.customer_id,
          address: address || [],
          address_default: address_default || {},
        },
        shipping_address
      });
      //lấy lại danh sách KH
      onFreshCustomers()
    }
  }
  
  return (
    <>
      <PageBody>
        <div className="nutri-title mb-3">Thông tin khách hàng</div>
        <Row>
          <Col md={7} xs={12}>
            <FormGroup className={`nutri-form ${onlyView ? 'copy_element' : ''}`}>
              <Label>
                <span>*</span> Chọn khách hàng
              </Label>
              <InputGroup>
                <Select
                  placeholder="Chọn"
                  className="react-select select-icon"
                  classNamePrefix="react-select"
                  maxMenuHeight={250}
                  isDisabled={onlyView}
                  onChange={(val: any) => {
                    let shipping_address = ''
                    let address_default = val?.address?.filter((itemFil:any)=> itemFil?.status === 1)
                    if(address_default[0]) {
                      address_default = address_default[0]
                      shipping_address = address_default?.street || ""
                      if(address_default?.wards_code?.name) shipping_address += ", " + address_default?.wards_code?.name
                      if(address_default?.district_code?.name) shipping_address += ", " + address_default?.district_code?.name
                      if(address_default?.provinces_code?.name) shipping_address += ", " + address_default?.provinces_code?.name
                    }
                    setData({
                      ...data,
                      customer_id: {
                        ...val,
                        id: val?.id,
                        phone: val?.phone,
                        birthday: val?.birthday,
                        sex: val?.sex,
                        address: val?.address || [],
                        address_default: address_default || {},
                      },
                      orderspackage: '',
                      shipping_address
                    });
                  }}
                  filterOption={(
                    candidate: { label: string; value: string; data: any },
                    input: string
                  ) => {
                    if (input) {
                      const status = candidate?.data?.name && TextUtils.removeVietNamese(candidate?.data?.name?.toLowerCase()).indexOf(TextUtils.removeVietNamese(input?.toLowerCase())) >= 0
                        || candidate?.data?.phone && TextUtils.removeVietNamese(candidate?.data?.phone?.toLowerCase()).indexOf(TextUtils.removeVietNamese(input?.toLowerCase())) >= 0
                      return status
                    }
                    return true;
                  }}
                  value={{
                      value: data?.customer_id?.id,
                      label: data?.customer_id?.name
                  }}
                  formatOptionLabel={(customer: any) => {
                      return (
                          <div>
                            {customer?.label}{customer?.phone && ` - ${customer?.phone}`}
                          </div>
                      );
                    }}
                  options={customers}
                ></Select>
                {type != "view" && (
                  <InputGroupAddon
                    addonType="append"
                    className="d-flex align-items-center"
                  >
                    <div
                      className="icon-input"
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        // router?.push(`/customer/add`)
                        // setIsOpen(true);
                        handleActionModal({data: {}, type:'addCustomer'});
                      }}
                    >
                      <i className="uil-plus"></i>
                    </div>
                  </InputGroupAddon>
                )}
              </InputGroup>
            </FormGroup>
          </Col>
          <Col md={5} xs={12}>
            <FormGroup className={`nutri-form only-view ${onlyView ? 'copy_element' : ''}`}>
              <Label>
                <span>*</span> Số điện thoại
              </Label>
              <InputGroup>
                <Input
                  type="text"
                  value={data?.customer_id?.phone}
                  name="phone"
                  placeholder="Nhập số điện thoại"
                />
                {type != "view" && (
                  <InputGroupAddon
                    onClick={() => {
                      data?.customer_id?.id &&
                        router?.push(`/customer/${data?.customer_id?.id}`);
                    }}
                    addonType="append"
                    className="d-flex align-items-center"
                    style={{ cursor: "pointer" }}
                  >
                    <img src={IconEdit} width={18} height={18} alt="" />
                  </InputGroupAddon>
                )}
              </InputGroup>
            </FormGroup>
          </Col>
        </Row>
        {/* {data?.type !== 'pos' && */}
        <Row>
          <Col md={12} xs={12}>
            <FormGroup className="nutri-form">
              <Label style={{
                display: 'flex',
                justifyContent: 'space-between'
              }}>
                <div><span className="text-danger">*</span> Địa chỉ giao hàng</div>
                {type !== "view" && data?.customer_id?.id && data?.customer_id?.address_default?.wards_code?.name &&
                  <span className="btn-add-address" onClick={()=>{
                    handleActionModal({data: {}, type:'changeAddress'})
                }}>Thay đổi</span>
                }
              </Label>
              <div className="value-text">
                {type === "view" ? data?.customer_id?.id && data?.shipping_address || "---" : data?.customer_id?.id && data?.shipping_address || ""}
                {/* {data?.customer_id?.id && data?.shipping_address || "---"} */}
                {type !== "view" && data?.customer_id?.id && !data?.shipping_address &&
                <div>
                  <span>Chưa có địa chỉ nhận hàng</span>
                  <span className="btn-add-address" onClick={()=>{
                      handleActionModal({data: {}, type:'addAddress'})
                  }}>Tạo mới</span>
                </div>}
              </div>
            </FormGroup>
          </Col>
        </Row>
        {/* } */}
      </PageBody>
      <ModalPopup isOpen={modalIsOpen} onRequestClose={() => setIsOpen(false)}>
        {(action?.type === 'addAddress' || action?.type === 'editAddress') &&
          <AddressAdd isDefault={action?.type === 'addAddress' ? true : false} closeModal={() => setIsOpen(false)} action={action} address={data?.customer_id?.address || []} setAddress={(address:any)=>handleSaveCusstomerAddress(address)} customer_id={data?.customer_id?.id} />
        }
         {(action?.type === 'changeAddress') &&
          <AddressChange closeModal={() => setIsOpen(false)} action={action} address={data?.customer_id?.address} setAddress={(address:any)=>{
            let shipping_address = ''
            let address_default = address?.filter((itemFil:any)=> itemFil?.status === 1)
            if(address_default[0]) {
              address_default = address_default[0]
              shipping_address = address_default?.street || ""
              if(address_default?.wards_code?.name) shipping_address += ", " + address_default?.wards_code?.name
              if(address_default?.district_code?.name) shipping_address += ", " + address_default?.district_code?.name
              if(address_default?.provinces_code?.name) shipping_address += ", " + address_default?.provinces_code?.name
            }
            setData({
              ...data,
              customer_id: {
                ...data?.customer_id,
                address: address || [],
                address_default: address_default || {},
              },
              shipping_address
            });
            //lấy lại danh sách KH
            onFreshCustomers()
          }} customer_id={data?.customer_id?.id} />
        }
        {action?.type === 'addCustomer' &&
          <div>
            <div className="modal-header">
              <h5 className="modal-title" id="modal-action-title">
                Thêm mới khách hàng
              </h5>
              <button
                onClick={() => setIsOpen(false)}
                type="button"
                className="close"
              >
                {" "}
                <span aria-hidden="true">×</span>{" "}
              </button>
            </div>
            <CustomerAdd
              closeModal={() => setIsOpen(false)}
              setDataFromExam={(val: any) => setData(val)}
              fetchCustomerExam = {onFreshCustomers}
              dataFromExam={data}
              from="exam"
            />
          </div>
        }
      </ModalPopup>
    </>
  );
};
export default OrderAddCustomer;
